export default {
  async getUserInfo ({ rootGetters, commit }) {
    const data = await rootGetters.GET('get-user')
    commit('setProperty', { name: 'user', value: data })
  }
}
